import { createSelector } from 'reselect'
import { IStoreState } from '../../reducers/types'

const selectTilsynstyper = (state: IStoreState) =>
  state.kvittering.tilsynstyper.data
const selectHentedeKvitteringer = (state: IStoreState) =>
  state.kvittering.hentedeKvitteringer

export const kvitteringSelectors = {
  getTypeBeskrivelse: (typeTilsyn: string) =>
    createSelector(selectTilsynstyper, (tilsynstyper) =>
      tilsynstyper
        .filter((t) => t.typeTilsynKey === typeTilsyn)
        .map((t) => t.beskrivelse)
    ),
  getKvitteringerFraKollega: createSelector(
    selectHentedeKvitteringer,
    (hentedeKvitteringer) => hentedeKvitteringer?.kvitteringer ?? []
  ),
  getKvitteringerFraKollegaLoadingStatus: createSelector(
    selectHentedeKvitteringer,
    (hentedeKvitteringer) => ({
      loading: hentedeKvitteringer?.loading ?? false,
      loaded: hentedeKvitteringer?.loaded ?? false,
      error: hentedeKvitteringer?.error,
    })
  ),
  getCurrentKvitteringId: createSelector(
    (state: IStoreState) => state.kvittering,
    ({ currentKvitteringId }) => currentKvitteringId
  ),
}
